/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const apple_watch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.778 12.2v1.867c0 .247.093.485.26.66a.868.868 0 0 0 .629.273h2.666a.868.868 0 0 0 .629-.273.957.957 0 0 0 .26-.66V12.2m-4.444 0h4.444m-4.444 0C4.796 12.2 4 11.364 4 10.333V5.667C4 4.636 4.796 3.8 5.778 3.8m4.444 8.4c.982 0 1.778-.836 1.778-1.867V5.667c0-1.031-.796-1.867-1.778-1.867m0 0V1.933a.957.957 0 0 0-.26-.66A.868.868 0 0 0 9.333 1H6.667a.868.868 0 0 0-.629.273.958.958 0 0 0-.26.66V3.8m4.444 0H5.778"
    />
  </svg>
)
export default apple_watch
